// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
  imported from Modal.module.scss 
 */
/*
 * 1. В мобильном сафари есть неприятный bug, связанный с -webkit-overflow-scrolling: touch. Дело в том, что при
 * применении этого свойства, вложенный контент может просто пропадать, это решается включением аппаратного
 * рендеринга, что и сделано. Подробнее http://cantina.co/thought_leadership/ios-5-native-scrolling-grins-and-gothcas/
 */
.Modal-module-Root_A_x {
  display: none; }

.Modal-module-Wrapper_GE3 {
  position: fixed;
  z-index: 1300;
  top: 0;
  left: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 100%; }

.Modal-module-Table_2bm {
  display: table;
  width: 100%;
  height: 100%; }

.Modal-module-Cell_2YF {
  display: table-cell;
  text-align: center; }

.Modal-module-topAlignCell_2VE {
  vertical-align: top; }

.Modal-module-middleAlignCell_1E5 {
  vertical-align: middle; }

.Modal-module-bottomAlignCell_33k {
  vertical-align: bottom; }

.Modal-module-Content_Xrh {
  position: relative;
  z-index: 1;
  display: inline-block;
  text-align: left;
  border-radius: 16px;
  transform: translate3d(0, 0, 0);
  /* 1 */ }

.Modal-module-Overlay_xL7 {
  position: fixed;
  z-index: 30;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  touch-action: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }

.Modal-module-visible_386 {
  display: block; }

.Modal-module-defaultVariant_Tvo {
  /* Устанавливаем display: block, для того, чтобы правильно отработала анимация на закрытие. */
  display: block;
  visibility: hidden;
  margin: -9999px 0 0 -9999px;
  /* 1 */ }
  .Modal-module-defaultVariant_Tvo .Modal-module-Content_Xrh {
    margin: 5px;
    padding: 10px;
    background-color: #fff; }
  .Modal-module-defaultVariant_Tvo .Modal-module-Overlay_xL7 {
    background-color: rgba(51, 63, 72, 0.8); }
  .Modal-module-defaultVariant_Tvo.Modal-module-visible_386 {
    visibility: visible;
    margin: 0;
    opacity: 1; }
  .Modal-module-defaultVariant_Tvo,
  .Modal-module-defaultVariant_Tvo .Modal-module-Content_Xrh {
    animation-duration: 0.2s;
    animation-timing-function: ease-in-out; }
  .Modal-module-defaultVariant_Tvo.Modal-module-hasAnimation_3ec {
    animation-name: Modal-module-Modal_variant_default_LF9; }
  .Modal-module-defaultVariant_Tvo.Modal-module-hasAnimation_3ec .Modal-module-Content_Xrh {
    animation-name: Modal-module-Modal-Content_variant_default_1Xv; }
  .Modal-module-defaultVariant_Tvo.Modal-module-visible_386.Modal-module-hasAnimation_3ec .Modal-module-Content_Xrh {
    animation-name: Modal-module-Modal-Content_variant_default_visible_-iz; }

@keyframes Modal-module-Modal_variant_default_LF9 {
  0% {
    visibility: visible;
    margin: 0; }
  99% {
    margin: 0; }
  100% {
    visibility: hidden;
    margin: -9999px 0 0 -9999px;
    /* 3 */ } }

@keyframes Modal-module-Modal-Content_variant_default_1Xv {
  0% {
    transform: scale(1); }
  100% {
    transform: scale(1.5); } }

@keyframes Modal-module-Modal-Content_variant_default_visible_-iz {
  0% {
    transform: scale(0.75); }
  100% {
    transform: scale(1); } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Modal/Modal.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;EAEE;AACF;;;;EAIE;AACF;EACE,aAAa,EAAE;;AAEjB;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,cAAc;EACd,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB,EAAE;;AAEvB;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,MAAM,EAAE;;AAEV;EACE,eAAe;EACf,WAAW;EACX,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,6CAA6C,EAAE;;AAEjD;EACE,cAAc,EAAE;;AAElB;EACE,6FAA6F;EAC7F,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,MAAM,EAAE;EACR;IACE,WAAW;IACX,aAAa;IACb,sBAAsB,EAAE;EAC1B;IACE,uCAAuC,EAAE;EAC3C;IACE,mBAAmB;IACnB,SAAS;IACT,UAAU,EAAE;EACd;;IAEE,wBAAwB;IACxB,sCAAsC,EAAE;EAC1C;IACE,sDAAsD,EAAE;EAC1D;IACE,8DAA8D,EAAE;EAClE;IACE,sEAAsE,EAAE;;AAE5E;EACE;IACE,mBAAmB;IACnB,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,MAAM,EAAE,EAAE;;AAEd;EACE;IACE,mBAAmB,EAAE;EACvB;IACE,qBAAqB,EAAE,EAAE;;AAE7B;EACE;IACE,sBAAsB,EAAE;EAC1B;IACE,mBAAmB,EAAE,EAAE","sourcesContent":["@charset \"UTF-8\";\n/*\n  imported from Modal.module.scss \n */\n/*\n * 1. В мобильном сафари есть неприятный bug, связанный с -webkit-overflow-scrolling: touch. Дело в том, что при\n * применении этого свойства, вложенный контент может просто пропадать, это решается включением аппаратного\n * рендеринга, что и сделано. Подробнее http://cantina.co/thought_leadership/ios-5-native-scrolling-grins-and-gothcas/\n */\n.Modal-module-Root_A_x {\n  display: none; }\n\n.Modal-module-Wrapper_GE3 {\n  position: fixed;\n  z-index: 1300;\n  top: 0;\n  left: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n  height: 100%; }\n\n.Modal-module-Table_2bm {\n  display: table;\n  width: 100%;\n  height: 100%; }\n\n.Modal-module-Cell_2YF {\n  display: table-cell;\n  text-align: center; }\n\n.Modal-module-topAlignCell_2VE {\n  vertical-align: top; }\n\n.Modal-module-middleAlignCell_1E5 {\n  vertical-align: middle; }\n\n.Modal-module-bottomAlignCell_33k {\n  vertical-align: bottom; }\n\n.Modal-module-Content_Xrh {\n  position: relative;\n  z-index: 1;\n  display: inline-block;\n  text-align: left;\n  border-radius: 16px;\n  transform: translate3d(0, 0, 0);\n  /* 1 */ }\n\n.Modal-module-Overlay_xL7 {\n  position: fixed;\n  z-index: 30;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  touch-action: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }\n\n.Modal-module-visible_386 {\n  display: block; }\n\n.Modal-module-defaultVariant_Tvo {\n  /* Устанавливаем display: block, для того, чтобы правильно отработала анимация на закрытие. */\n  display: block;\n  visibility: hidden;\n  margin: -9999px 0 0 -9999px;\n  /* 1 */ }\n  .Modal-module-defaultVariant_Tvo .Modal-module-Content_Xrh {\n    margin: 5px;\n    padding: 10px;\n    background-color: #fff; }\n  .Modal-module-defaultVariant_Tvo .Modal-module-Overlay_xL7 {\n    background-color: rgba(51, 63, 72, 0.8); }\n  .Modal-module-defaultVariant_Tvo.Modal-module-visible_386 {\n    visibility: visible;\n    margin: 0;\n    opacity: 1; }\n  .Modal-module-defaultVariant_Tvo,\n  .Modal-module-defaultVariant_Tvo .Modal-module-Content_Xrh {\n    animation-duration: 0.2s;\n    animation-timing-function: ease-in-out; }\n  .Modal-module-defaultVariant_Tvo.Modal-module-hasAnimation_3ec {\n    animation-name: Modal-module-Modal_variant_default_LF9; }\n  .Modal-module-defaultVariant_Tvo.Modal-module-hasAnimation_3ec .Modal-module-Content_Xrh {\n    animation-name: Modal-module-Modal-Content_variant_default_1Xv; }\n  .Modal-module-defaultVariant_Tvo.Modal-module-visible_386.Modal-module-hasAnimation_3ec .Modal-module-Content_Xrh {\n    animation-name: Modal-module-Modal-Content_variant_default_visible_-iz; }\n\n@keyframes Modal-module-Modal_variant_default_LF9 {\n  0% {\n    visibility: visible;\n    margin: 0; }\n  99% {\n    margin: 0; }\n  100% {\n    visibility: hidden;\n    margin: -9999px 0 0 -9999px;\n    /* 3 */ } }\n\n@keyframes Modal-module-Modal-Content_variant_default_1Xv {\n  0% {\n    transform: scale(1); }\n  100% {\n    transform: scale(1.5); } }\n\n@keyframes Modal-module-Modal-Content_variant_default_visible_-iz {\n  0% {\n    transform: scale(0.75); }\n  100% {\n    transform: scale(1); } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
